import * as React from 'react';
import { Affix, Tooltip } from 'antd';

type Item = {
    key: string,
    offsetBottom?: number,
    offsetTop?: number,
    target?: () => HTMLElement,
    onChange?: any,
    style?: any,
    title?: string,
    placement?: string,
    custom: JSX.Element | Function
};

interface iProps {
    options: Array<Item>;
    style?: any;
}

export default class AffixContainer extends React.Component<iProps> {

    /**
     * 子组件默认配置
     */
    private defaults: any = {
        className: 'Affix-item-content'
    };

    render() {
        const { options, style } = this.props;
        return (
            <span className='Affix' style={style}>
                {options.map(({ key, offsetBottom, offsetTop, target, onChange, custom, style, title, placement }: any) => (
                    <Tooltip key={key} placement={placement || 'left'} overlayStyle={{ position: 'fixed' }}
                             title={title}>
                         <span className='Affix-item'>
                              <Affix style={style} offsetBottom={offsetBottom} offsetTop={offsetTop} target={target}
                                     onChange={onChange}>
                                  {
                                      typeof (custom) === 'function'
                                          ? custom(this.defaults)
                                          : <div {...this.defaults}>{custom || '-'}</div>
                                  }
                              </Affix>
                        </span>
                    </Tooltip>
                ))}
            </span>
        );
    }
}
